import React, { Component } from 'react';
import { connect } from 'react-redux';
import Formsy from 'formsy-react';
import translator from '../../../components/localization/translator';
import { Modal} from 'react-bootstrap';
import dispatchConfig from "../../../config/dispatchConfig";
import FooterButtons from '../../../components/common/elements/FooterButtons';
import FormInput from '../../../components/common/elements/FormInput';
import { closeDispatchModal, createDispatchConfigByAPI, updateDispatchConfigByAPI } from '../dispatch.action'
import security from '../../../components/common/security/security';

class DispatchConfigDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dispatchData: {},
            isDisabled: false
        };
    }

    componentWillReceiveProps(nextProps) {
        if(nextProps.dispatchDetails && nextProps.dispatchDetails.selectedDispatch !== undefined){
            this.state.dispatchData = nextProps.dispatchDetails.selectedDispatch
        }
	}
  

    save() {
        const id = this.state.dispatchData._id;
        if(id) {
            const data = {...this.state.dispatchData};
            delete data._id;
            this.update(id, data, () => {
                this.cancel();
            });
        } else {
            this.create(this.state.dispatchData, () => {
                this.cancel();
            })
        }
    }

    create = (data, cb) => {
        this.props.createDispatchConfigByAPI(data, cb);
    }

    update = (id, data, cb) => {
        this.props.updateDispatchConfigByAPI(id, data, cb);
    }

    cancel = () => {
        this.props.closeDispatchModal();
        this.setState({dispatchData: {}, isDisabled: true});
    }

    renderFooter() {
		return (
			<Modal.Footer>
				<FooterButtons
					cancelButton={translator.translate("_cancel_")}
					saveButton={translator.translate("_save_")}
					save={this.save.bind(this)}
					cancel={this.cancel}
                    isDisabled={this.state.isDisabled}
                    />
			</Modal.Footer>
		);
    }


	disableButton = () => {
        this.setState({ isDisabled: true });
	}

	enableButton = () => {
		this.setState({ isDisabled: false });
    }

    getTitle() {
        const selectedDispatch = this.props.dispatchDetails.selectedDispatch || {};
        return <b>{selectedDispatch._id ? translator.translate('_update_config_') : translator.translate('_create_config_')}</b>;
    }

    renderInput(field, id) {
		const change = field.canChange;
		if (!change) {
			return null;
		}
		const key = field.key;
		return(
			<FormInput
				key={id}
				htmlFor={id}
				label={field.title}
				type={change.type}
				id={key}
				name={key}
				value={this.state.dispatchData[key]}
				onChange={(e) => {
					this.setState({dispatchData :{
                        ...this.state.dispatchData,
                        [key]: e.target.value
                    }});
				}}
				validations={change.validations}
				validationErrors={change.validationErrors}
				required={field.isRequired === false ? false : true} />
		);
	}

    render() {
        return (
            <Modal
                bsSize='large'
                show={this.props.dispatchDetails.showModal}
                onHide={this.cancel}>
				<Modal.Header closeButton>
					<Modal.Title>
                        {this.getTitle()}
					</Modal.Title>
				</Modal.Header>
                <Modal.Body className="scrollable modal-possition">
                    <Formsy onValid={this.enableButton} onInvalid={this.disableButton}>
                    <div>
                        {dispatchConfig.getColumns(security.getUser().role).map(this.renderInput.bind(this))}
                    </div>
                    </Formsy>
				</Modal.Body>
                {this.renderFooter()}
			</Modal>
        );
    }
}

let mapStateToProps = (state) => {
    return {
        dispatchDetails: state.dispatch
    };
};
export default connect(mapStateToProps, {
    createDispatchConfigByAPI,
    updateDispatchConfigByAPI,
    closeDispatchModal
})(DispatchConfigDetails);
